$.fn.getHashFromUrl = function(url) {
    return $("<a />").attr("href", url)[0].hash.replace(/^#/, "");
}

$.fn.setCookie = function(key, value, expiryDays) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiryDays * 24 * 60 * 60 * 1000));
    document.cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value) + ';expires=' + expires.toUTCString() + ';path=/';
}

$.fn.getCookie = function(key) {
    var cookies = document.cookie.split('; ');
    for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        if (decodeURIComponent(parts[0]) === key) {
            return decodeURIComponent(parts[1]);
        }
    }
    return null;
}

$.fn.deleteCookie = function(key) {
    document.cookie = encodeURIComponent(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
}


$(document).ready(function() {

    var mobileNavActive = false;

    // Header Mobile Menu Button
    $('.toggle-nav-btn').on('click', function(){
        if(!mobileNavActive) {
            $('html').addClass('mobile-nav-active');
            mobileNavActive = true;
        } else{
            $('html').removeClass('mobile-nav-active');
            mobileNavActive = false;
        }
    });
    
    // Header Menu Smooth Scrolling

    $('#nav-main a[href^="#"]').on('click',function(e){
        e.preventDefault();
        if(mobileNavActive){
            $('html').removeClass('mobile-nav-active');
            mobileNavActive = false;
        }
        $('#nav-main .nav-item').removeClass('current');
        $(this).closest('.nav-item').addClass('current');
        var navHeight = $('#nav-main').height();
        var anchor = $(this).attr('href');
        $('html, body').animate({scrollTop: $(anchor).offset().top - navHeight }, 'slow');
    });

    // Content Buttons Smooth Scrolling

    $('.btn-anchor').on('click',function(e){
        e.preventDefault();
        var navHeight = $('#main-nav').height();
        var anchor = $(this).attr('href');
        $('html, body').animate({scrollTop: $(anchor).offset().top - navHeight }, 'slow');
    });

    // Content Buttons Smooth Scrolling
    // Form Buttons with autoselect form option

    $('.btn-anchor-form').on('click',function(e){
        e.preventDefault();
        var navHeight = $('.nav-main').height();
        var anchor = $(this).attr('href');
        var form = $(this).data('form-id');
        var selected = $(this).data('selected');
        var option = 'option[data-selected="'+selected +'"]';
        $('#'+ form).find('option').prop("selected", false);
        $('#'+ form).find(option).prop("selected", true); //$('#'+ form).find(option).attr('selected','selected');
        $('html, body').animate({scrollTop: $(anchor).offset().top - navHeight }, 'slow');
    });

    // Toogle Buttons Footer

    $('.toggle-btn').on('click',function(e){
        e.preventDefault();

        $('.toggle').removeClass('is-active');
        $('.toggle-btn').removeClass('is-active');

        $(this).toggleClass('is-active');
        var anchor = $(this).attr('href');
        $(anchor).toggleClass('is-active');

        $('html, body').animate({scrollTop: $(anchor).offset().top }, 'slow');
    });

    
    // Modal (Infos)
    if($('.modal').length !== 0) {

        var cookieValue = $(document).getCookie(js_vars.cookie_name);
        var modalAlreadyShown = false;

        if(cookieValue !== 'hide_modal') {
            setTimeout(function() {
                if(!modalAlreadyShown) {
                    $('html').addClass('modal-is-visible');
                    $('.modal').addClass('is-visible');
                    modalAlreadyShown = true;
                }
            }, js_vars.modal_timeout);
        } else {
            console.info('Modal hidden.');
        }
    
        $('.modal [data-modal="hide"]').on('click', function(e) {
            e.preventDefault();
            $(document).setCookie(js_vars.cookie_name, 'hide_modal', 30);
            $(this).closest('.modal').removeClass('is-visible');
            $('html').removeClass('modal-is-visible');
        });
    
        $('.modal [data-modal="close"]').on('click', function(e) {
            e.preventDefault();
            $(this).closest('.modal').removeClass('is-visible');
            $('html').removeClass('modal-is-visible');
        });
    }




    



});


